<template>
  <div>
    <b-nav-item v-if="!isLoggedIn" @click="goLogin">
      登录/注册
    </b-nav-item>
    <b-nav-item-dropdown v-else right>
      <template #button-content>
        <span v-if="avatarUrl" class="d-inline-block mr-2" style="width:24px;height:24px;border-radius:50%;overflow:hidden;vertical-align:middle;"><img :src="avatarUrl" style="width:24px;height:24px;object-fit:cover;" /></span>
        <span v-else class="d-inline-flex mr-2 align-items-center justify-content-center" style="width:24px;height:24px;border-radius:50%;background:#eee;color:#555;font-size:12px;">{{ firstLetter }}</span>
        <span>{{ displayName }}</span>
      </template>
      <b-dropdown-item @click="goProfile">设置</b-dropdown-item>
      <b-dropdown-item @click="toggleTheme">{{ themeLabel }}</b-dropdown-item>
      <b-dropdown-item @click="toggleColorblind">{{ colorblindLabel }}</b-dropdown-item>
      <b-dropdown-item @click="goHome">个人主页</b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item @click="logout">退出登录</b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import { request_zzquant } from '@/network/request.js'

export default {
  name: 'UserMenu',
  data() {
    return {
      isLoggedIn: false,
      userInfo: null,
      loginHandlerRef: null,
      logoutHandlerRef: null,
      theme: 'light',
      colorblind: false
    }
  },
  computed: {
    displayName() {
      const u = this.userInfo || {}
      return u.user_nick || u.user_name || u.email || '账户'
    },
    avatarUrl(){
      const u = this.userInfo || {}
      const url = u.avatar_url || u.avatar
      if (!url) return ''
      return url.startsWith('http') ? url : ('https://api.zizizaizai.com' + url)
    },
    firstLetter(){
      const name = this.displayName || ''
      return name ? name.substr(0,1) : '?'
    },
    themeLabel(){ return this.theme === 'dark' ? '浅色皮肤' : '黑色皮肤' },
    colorblindLabel(){ return this.colorblind ? '关闭色弱模式' : '开启色弱模式' }
  },
  mounted() {
    this.readLocal()
    try{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }catch(e){ console.warn('theme read failed', e) }
    try{ const c = localStorage.getItem('site.colorblind'); if(c){ this.colorblind = (c==='1' || c==='true') } }catch(e){ console.warn('colorblind read failed', e) }
    this.loginHandlerRef = (evt) => {
      try {
        if (evt && evt.detail && evt.detail.userInfo) {
          this.userInfo = evt.detail.userInfo
        }
      } catch (e) { console.warn('user-login event parse failed', e) }
      this.isLoggedIn = !!localStorage.getItem('token')
    }
    this.logoutHandlerRef = () => {
      this.isLoggedIn = false
      this.userInfo = null
    }
    window.addEventListener('user-login', this.loginHandlerRef)
    window.addEventListener('user-logout', this.logoutHandlerRef)
    if (this.isLoggedIn) {
      this.loadProfile()
    }
  },
  beforeDestroy() {
    window.removeEventListener('user-login', this.loginHandlerRef)
    window.removeEventListener('user-logout', this.logoutHandlerRef)
  },
  methods: {
    readLocal() {
      try {
        this.isLoggedIn = !!localStorage.getItem('token')
        const raw = localStorage.getItem('user_info')
        if (raw) this.userInfo = JSON.parse(raw)
      } catch (e) {
        this.isLoggedIn = !!localStorage.getItem('token')
        this.userInfo = null
        console.warn('readLocal user_info failed', e)
      }
    },
    goLogin() {
      try {
        const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/'
        this.$router.push({ path: '/login', query: { redirect: current } })
      } catch (e) {
        this.$router.push('/login')
      }
    },
    goProfile() { this.$router.push('/me/profile') },
    goHome() { this.$router.push('/me/home') },
    applyTheme(){ const isDark = this.theme === 'dark'; document.body.classList.toggle('theme-dark', isDark); try{ localStorage.setItem('site.theme', this.theme); window.dispatchEvent(new CustomEvent('site-theme-changed', { detail:{ theme:this.theme } })) }catch(e){ console.warn('theme set failed', e) } },
    toggleTheme(){ this.theme = (this.theme==='dark') ? 'light' : 'dark'; this.applyTheme() },
    applyColorblind(){ try{ localStorage.setItem('site.colorblind', this.colorblind ? '1' : '0'); window.dispatchEvent(new CustomEvent('site-colorblind-changed', { detail:{ colorblind: !!this.colorblind } })) }catch(e){ console.warn('colorblind set failed', e) } },
    toggleColorblind(){ this.colorblind = !this.colorblind; this.applyColorblind() },
    loadProfile(){
      request_zzquant({ url: '/user/profile/me', method: 'GET' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {}
        const info = Object.assign({}, this.userInfo || {}, { id: d.id, user_name: d.user_name, user_nick: d.user_nick, avatar_url: d.avatar_url, roles: d.roles })
        this.userInfo = info
        try { localStorage.setItem('user_info', JSON.stringify(info)) } catch(e) { console.warn('persist user_info failed', e) }
      }).catch(()=>{})
    },
    async logout() {
      const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/'
      try {
        await request_zzquant({ url: '/v2/login/logout', method: 'post' })
      } catch (e) {
        console.warn('logout api failed', e)
      } finally {
        try {
          localStorage.removeItem('token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('user_info')
        } catch (e) { console.warn('clear local auth failed', e) }
        window.dispatchEvent(new CustomEvent('user-logout'))
        this.$router.push({ path: '/login', query: { redirect: current } })
      }
    }
  }
}
</script>

<style scoped>
</style>
